import React, { Component } from "react";
import Button from "../../Button/Button";
import Progress from "../Progress/Progress";
import "./Form.css";

class Form extends Component {
	// Initial signup form before onboarding
	render() {
		return (
			<div className="signup-form">
				<div className="signup-form-l container">
					<Progress
						onboardingStep={this.props.onboardingStep}
						onboardingFlow={this.props.onboardingFlow}
					/>
					<form onSubmit={e => this.props.nextOnboarding(e)}>
						<label>First Name</label>
						<input type="text" autoComplete="given-name" value={this.props.signUpParams['firstName']} onChange={e => this.props.onChangeInput('firstName', e.target.value, 'signUpParams')}/>
						<label>Last Name</label>
						<input type="text" autoComplete="family-name" value={this.props.signUpParams['lastName']} onChange={e => this.props.onChangeInput('lastName', e.target.value, 'signUpParams')}/>
						<label>Company</label>
						<input type="text" autoComplete="institution" value={this.props.signUpParams['institution']} onChange={e => this.props.onChangeInput('institution', e.target.value, 'signUpParams')}/>
						<label>Email</label>
						<input type="email" autoComplete="email" value={this.props.signUpParams['user']} onChange={e => this.props.onChangeInput('user', e.target.value, 'signUpParams')}/>
						<label>Password</label>
						<input type="password" value={this.props.signUpParams['pass']} onChange={e => this.props.onChangeInput('pass', e.target.value, 'signUpParams')}/>
						<label>Confirm Password</label>
						<input type="password" value={this.props.signUpParams['pass2']} onChange={e => this.props.onChangeInput('pass2', e.target.value, 'signUpParams')}/>
						<Button label="Next" />
					</form>
				</div>
			</div>
		);
		//	<div className="signup-form-r container" style={{backgroundImage: `url(${this.props.trianglify})`}}/>
	}
}

export default Form;


// WEBPACK FOOTER //
// ./src/components/SignUp/Form/Form.js